import CommunicationConst from "components/communication/communication-const";
import EquipmentConst from "components/equipment/equipment-const";
import ExhibitionConst from "components/exhibition/exhibition-const";
import FlooringConst from "components/flooring/flooring-const";
import GraphicConst from "components/graphic/graphic-const";
import OrganizerConst from "components/organizer/organizer-const";
import PermissionConst from "components/permission/permission-const";
import RoleConst from "components/role/role-const";
import StandConst from "components/stand/stand-const";
import SupplierConst from "components/supplier/supplier-const";
import TeamConst from "components/team/team-const";
import UserConst from "components/user/users-const";
import VariableConst from "components/variable/variable-const";
import { createPermissionCheck } from "./permission-utils";

type HasPermissionFn = (
  permissionSlug: string,
  entryPoint?: string,
  groupName?: string,
  action?: string
) => boolean;

const permissionsViewPermission = createPermissionCheck(
  "permission_view_permissions",
  "library",
  "permission_group_permissions",
  "permission_action_view"
);

const SMART_HOME_ROUTE_CHECKS = [
  { route: UserConst.basePath, permission: UserConst.permissions.VIEW },
  { route: RoleConst.basePath, permission: RoleConst.permissions.VIEW },
  { route: SupplierConst.basePath, permission: SupplierConst.permissions.VIEW },
  { route: TeamConst.basePath, permission: TeamConst.permissions.VIEW },
  { route: FlooringConst.basePath, permission: FlooringConst.permissions.VIEW },
  { route: EquipmentConst.basePath, permission: EquipmentConst.permissions.VIEW },
  { route: StandConst.basePath, permission: StandConst.permissions.VIEW },
  { route: CommunicationConst.basePath, permission: CommunicationConst.permissions.VIEW },
  { route: VariableConst.basePath, permission: VariableConst.permissions.VIEW },
  { route: GraphicConst.basePath, permission: GraphicConst.permissions.VIEW },
  { route: ExhibitionConst.basePath, permission: ExhibitionConst.permissions.VIEW },
  { route: OrganizerConst.basePath, permission: OrganizerConst.permissions.VIEW },
  { route: PermissionConst.basePath, permission: permissionsViewPermission },
];

export const getAvailableHomeRoute = (
  hasPermission: HasPermissionFn,
  isDeveloper: boolean
): string | null => {
  if (isDeveloper) {
    return UserConst.basePath;
  }

  const matchedRoute = SMART_HOME_ROUTE_CHECKS.find(({ permission }) =>
    hasPermission(
      permission.slug,
      permission.entryPoint,
      permission.groupName,
      permission.action
    )
  );

  return matchedRoute?.route ?? null;
};

